"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateScheduleTaskResult = exports.CreateScheduleTaskPayload = void 0;
const class_validator_1 = require("class-validator");
const is_cron_expression_1 = require("../../../../common/custom-validators/is-cron-expression");
const base_create_result_dto_1 = require("../../../../common/dtos/base-create-result.dto");
class CreateScheduleTaskPayload {
}
__decorate([
    (0, class_validator_1.IsUUID)()
], CreateScheduleTaskPayload.prototype, "scheduleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, is_cron_expression_1.IsCronExpression)()
], CreateScheduleTaskPayload.prototype, "cronSchedule", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)()
], CreateScheduleTaskPayload.prototype, "actionId", void 0);
exports.CreateScheduleTaskPayload = CreateScheduleTaskPayload;
class CreateScheduleTaskResult extends base_create_result_dto_1.BaseCreateResult {
}
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)()
], CreateScheduleTaskResult.prototype, "scheduleTask", void 0);
exports.CreateScheduleTaskResult = CreateScheduleTaskResult;
